/**
 * API Configuration
 * -----------------
 * This file centralizes the backend URL logic.
 */

const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const isLocal = hostname === "localhost" || 
                  hostname === "127.0.0.1" || 
                  hostname.startsWith("192.168.") || 
                  hostname.startsWith("10.");

  // 1. Check for Environment Variable (Set during build)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Development Fallback
  if (isLocal) {
    return `http://${hostname}:5000`;
  }

  // 3. PRODUCTION FALLBACK (HARDCODED)
  // If your backend is NOT on the same domain, paste your backend URL here:
  // Example: return "https://triothoughtsolution-backend-1.onrender.com";
  
  return ""; // Default to relative path (same domain)
};

export const API_BASE_URL = getApiBaseUrl();
export const IS_PRODUCTION = !window.location.hostname.includes("localhost");

console.log(`[API Config] Active Base URL: ${API_BASE_URL || "Relative (Same Domain)"}`);
